// ============================================================================
// Shared QueryClient.
// ----------------------------------------------------------------------------
// One instance for the app. Defaults tuned for a live-synced app: queries are
// considered fresh for a short window (the WebSocket pushes invalidations, so
// aggressive polling is unnecessary) and we don't retry a 401 — that means the
// session is gone and the auth layer should redirect to /login.
// ============================================================================
import { QueryClient } from "@tanstack/react-query";
import { ApiError } from "../api";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      // Belt-and-suspenders for the live-sync offline gap: if the WS missed a
      // change while disconnected (sleep/network blip), refetching stale data on
      // window-focus and network-reconnect converges the UI. The 30s staleTime
      // keeps these from being chatty during normal connected use.
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      retry: (failureCount, error) => {
        // Never retry auth failures — surface them so we can redirect.
        if (error instanceof ApiError && error.isUnauthorized) return false;
        return failureCount < 2;
      },
    },
    mutations: {
      retry: false,
    },
  },
});
